import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { URLSearchParams } from "url";

import { Tab } from "@pentabd/ui";

import { ErrorModal, SuccessModal } from "@components";

import ProcurementList from "./ProcurementsList";
import GiftList from "./GiftList";
import ExistingProductsList from "./ExistingProductList";

interface IDType {
  id: number | null;
}

export const Procurement = ({ id }: IDType) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<number>(0);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [searchParams, setSearchParams]: [URLSearchParams, Function] =
    useSearchParams();
  const changeActiveTab = setActiveTab;

  const closeErrorModal = () => setIsErrorModalOpen(false);
  const closeSuccessModal = () => setIsSuccessModalOpen(false);

  const tabData = [
    {
      label: t("PROCUREMENTS_LIST.TABS.PROCUREMENTS"),
      component: (
        <ProcurementList
          id={id}
          setSearchParams={setSearchParams}
          changeActiveTab={changeActiveTab}
          // setIsErrorModalOpen={setIsErrorModalOpen}
          // setIsSuccessModalOpen={setIsSuccessModalOpen}
        />
      ),
    },
    {
      label: t("PROCUREMENTS_LIST.TABS.GIFT"),
      component: (
        <GiftList
          id={id}
          setSearchParams={setSearchParams}
          changeActiveTab={changeActiveTab}
          procurementType="GIFT_PRODUCT"
          // setIsErrorModalOpen={setIsErrorModalOpen}
          // setIsSuccessModalOpen={setIsSuccessModalOpen}
        />
      ),
    },
    {
      label: t("PROCUREMENTS_LIST.TABS.EXISTING_ITEM"),
      component: (
        <ExistingProductsList
          id={id}
          setSearchParams={setSearchParams}
          changeActiveTab={changeActiveTab}
          procurementType="EXISTING_PRODUCT"
          // setIsErrorModalOpen={setIsErrorModalOpen}
          // setIsSuccessModalOpen={setIsSuccessModalOpen}
        />
      ),
    },
  ];

  useEffect(() => {
    setActiveTab((prev) => (prev = Number(searchParams.get("tab"))));
  }, [searchParams]);

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
    };
    return reset();
  }, []);

  return (
    <>
      <SuccessModal
        isModalOpen={isSuccessModalOpen}
        action={closeSuccessModal}
      />
      <ErrorModal isModalOpen={isErrorModalOpen} closeModal={closeErrorModal} />
      <Tab active={activeTab} setActiveTab={changeActiveTab}>
        <Tab.Heads>
          {tabData.map(({ label }, i) => (
            <Tab.Item
              key={i}
              index={i}
              label={label}
              // disabled={i > 0 && !id ? true : false}
            />
          ))}
        </Tab.Heads>
        <Tab.ContentWrapper>
          {tabData.map(({ component }, i) => (
            <Tab.Content key={i} index={i}>
              {component}
            </Tab.Content>
          ))}
        </Tab.ContentWrapper>
      </Tab>
    </>
  );
};
